import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { MetaBlock } from '@gem/components';
import { IcSCopyIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton } from '@gem/ui-kit';

import { useCopyToClipboard } from 'APP/hooks/useCopyToClipboard/useCopyToClipboard';

import styles from './CallLink.styles.m.css';

interface IProfileEmailProps {
  className?: string;
  link: string;
  isSendMail?: boolean;
}

export const CallLink: FC<IProfileEmailProps> = observer(({ link }) => {
  const { t } = useTranslation();
  const copyToClipboard = useCopyToClipboard(link, t('calendar_call_link_copied'));

  return (
    <MetaBlock
      label={t('calendar_event_call_link')}
      className={styles.metaBlock}
      Actions={
        <IconButton
          Icon={IcSCopyIcon}
          onClick={copyToClipboard}
        />
      }
    >
      <div
        className={styles.link}
        onClick={copyToClipboard}
        data-test="call-link"
      >
        {link}
      </div>
    </MetaBlock>
  );
});
